import React from 'react'

const ToggleIcon = ({ className = '' }) => (
  <svg
    className={className}
    width='56'
    height='28'
    viewBox='0 0 56 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0 14.0171C0 6.67464 5.95223 0.722412 13.2947 0.722412H42.7053C50.0478 0.722412 56 6.67464 56 14.0171C56 21.3595 50.0478 27.3118 42.7053 27.3118H13.2947C5.95223 27.3118 0 21.3595 0 14.0171Z'
      fill='#0FD08B'
    />
    <ellipse cx='42.5' cy='14.0171' rx='10.5' ry='10.3403' fill='white' />
  </svg>
)

export default ToggleIcon
